import { Alert, AlertTitle } from '@montugroup/design-system';
import { useParams } from 'react-router-dom';

import PageLoadErrorAlertContent from '@/components/error/PageLoadErrorAlertContent';
import { PortalPartnerLayout } from '@/components/layout/portal-partner-layout';
import useProductDetails from '@/hooks/products/useProductDetails';
import { useFeatureFlag } from '@/hooks/useFeatureFlag';
import { PATIENT_REFILL_ROUTE } from '@/routes/route-paths';
import { ProductDetails } from '@montugroup/circuit-shared/components/product-detail/ProductDetails';
import PageSkeleton from './components/PageSkeleton';

export default function ProductDetailsPage() {
  const enableProductDetailPageRealDeviceImages = useFeatureFlag('enable_product_detail_page_real_device_images');
  const { id: productId } = useParams();
  const { product, isError, isLoading, refetch } = useProductDetails(productId ?? '');

  const handleClickRetry = () => refetch();

  if (isLoading) {
    return <PageSkeleton />;
  }

  if (isError || !product) {
    return (
      <Alert severity="error">
        <AlertTitle>Page load error</AlertTitle>
        <PageLoadErrorAlertContent onClickRetry={handleClickRetry} />
      </Alert>
    );
  }

  return (
    <>
      <PortalPartnerLayout.Back backText="Back" defaultRoute={PATIENT_REFILL_ROUTE} />
      <ProductDetails
        product={product}
        showDescription={true}
        showUsage={true}
        enableProductDetailPageRealDeviceImages={enableProductDetailPageRealDeviceImages}
      />
    </>
  );
}
